<template>
  <div
    id="engagementsList"
    class="mainCard"
  >
    <div v-if="engagements.length > 0">
      <div
        v-for="(engagement, key) in engagements"
        :key="key"
        class="engagementItem"
        @click="goToDetails(engagement)"
      >
        <EngagementSummary :engagement="engagement" />
      </div>
    </div>

    <div
      v-else
      v-loading="loading"
    >
      <div class="noData">
        <span v-if="!loading">
          {{ $t('leader.engagement.noData') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import EngagementSummary from './components/EngagementSummary.vue';

export default {
  name: 'EngagementsList',

  components: {
    EngagementSummary,
  },

  data: () => ({
    loading: true,
    engagements: [],
  }),

  created() {
    this.getEngagements();
  },

  methods: {
    goToDetails(engagement) {
      this.$router.push({
        name: 'engagementDetails',
        params: { id: engagement.uuid },
      });
    },

    async getEngagements() {
      try {
        this.loading = true;
        const response = await api.getEngagements({ status: 'completed' });
        this.engagements = response.data.results;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#engagementsList {
  padding-top: 30px;

  .engagementItem {
    margin-bottom: 15px;
    cursor: pointer;
  }

  .noData {
    margin-top: 40px;
    padding: 30px 0;
    background-color: var(--themeCardColor);
    border-radius: 10px;
    color: var(--themeFontColor);
    text-align: center;
  }
}
</style>
